import React from "react";
import { steps } from "../data/content";
export function HowItWorks() {
  return <section className="px-5 py-20" data-id="element-58" data-mp="7slqt16is5sn">
      <div className="mx-auto max-w-5xl" data-id="element-59" data-mp="7tod0vswdk28">
        <h2 className="text-center font-display text-4xl uppercase text-cream sm:text-5xl" data-id="element-60" data-mp="7qirtrne32bs">
          Simple comme <span className="text-gold" data-id="element-61" data-mp="3u03hvevgbxok">1, 2, 3</span>
        </h2>
        <ol className="mt-14 grid gap-10 md:grid-cols-3" data-id="element-62" data-mp="3u0d893kes6us">
          {steps.map((s, i) => <li key={s.title} className="border-t-2 border-gold pt-6" data-id="element-63" data-mp="lkthqcb4h2jf" data-mpi={i}>
              <span className="font-display text-5xl text-gold" data-id="element-64" data-mp="qjmollvwlvam">{i + 1}</span>
              <h3 className="mt-3 text-2xl font-bold text-cream" data-id="element-65" data-mp="cs7zcxbekxv4">{s.title}</h3>
              <p className="mt-2 text-mute" data-id="element-66" data-mp="cq5bojxq3gtk">{s.desc}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}